import type { TQuestionAnswer } from '$/types/components/questions';

export enum StudiesVariant {
  FULL_TIME = 1998731,
  PART_TIME = 1998732,
  DISTANCE_LEARNING = 1998734,
  PART_TIME_STUDY = 4229811,
  DUAL_STUDY = 1998733,
  ONLINE_STUDY = 1998735,
}

export enum StudiesVariantName {
  FULL_TIME = 'Vollzeit',
  PART_TIME = 'Teilzeit',
  DISTANCE_LEARNING = 'Fernstudium',
  PART_TIME_STUDY = 'Berufsbegleitendes Studium',
  DUAL_STUDY = 'Duales Studium',
  ONLINE_STUDY = 'Onlinestudium',
}

const studiesVariantList: TQuestionAnswer<StudiesVariant>[] = [
  { id: StudiesVariant.FULL_TIME, value: StudiesVariantName.FULL_TIME },
  { id: StudiesVariant.PART_TIME, value: StudiesVariantName.PART_TIME },
  {
    id: StudiesVariant.DISTANCE_LEARNING,
    value: StudiesVariantName.DISTANCE_LEARNING,
  },
  {
    id: StudiesVariant.PART_TIME_STUDY,
    value: StudiesVariantName.PART_TIME_STUDY,
  },
  { id: StudiesVariant.DUAL_STUDY, value: StudiesVariantName.DUAL_STUDY },
  { id: StudiesVariant.ONLINE_STUDY, value: StudiesVariantName.ONLINE_STUDY },
];

export default studiesVariantList;
